export const actions = {
  addMultiple: 'ADD_PROGRAMS',
  update: 'UPDATE_PROGRAM',
  clear: 'CLEAR_PROGRAMS',
  remove: 'REMOVE_PROGRAM',
};

export const addPrograms = programs => ({
  type: actions.addMultiple,
  programs: programs,
});

export const updateProgram = (id, data) => ({
  type: actions.update,
  id: id,
  data: data,
});

export const clearPrograms = () => ({
  type: actions.clear,
});

export const removeProgram = id => ({
  type: actions.remove,
  id: id,
});
